import Vue from 'vue';

export default {
  state: {
    account_types: [],
  },
  getters: {
    account_types(state) {
      return state.account_types;
    },
    // eslint-disable-next-line
    account_type: state => (id) => {
      return state.account_types.find(type => type.id === id) || {};
    },
  },
  mutations: {
    SET_ACCOUNT(state, payload) {
      state.account_types = payload;
    },
  },
  actions: {
    GET_ACCOUNT(context) {
      return Vue.axios.get('filters/account_types').then((response) => {
        context.commit('SET_ACCOUNT', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/account_types.js